import './ActionButton.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var disabled = '_otmjah3-3-5-0';
export var navItem = _7a468({defaultClassName:'_otmjah0-3-5-0',variantClassNames:{density:{'default':'_otmjah1-3-5-0',condensed:'_otmjah2-3-5-0'}},defaultVariants:{},compoundVariants:[]});
export var navItemSelectionStyle = '_otmjah4-3-5-0';